import {useState} from 'react';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

import DeletionConfirmation from './DeletionConfirmation';
import HomeDeletionForm from './DeletionForm';
import {PostDeletePreviewResponse} from './services';
import {DeletePartner, DeletionSubmissionFormData, UserAccount} from './types';

type DeletionConfirmInitialData = Backend<{
    deletePartners: Array<DeletePartner>;
    hasMultiplePartners: boolean;
    hasReasons: boolean;
    userAccount: UserAccount;
}>;

const DeletionConfirm = () => {
    const {data} = useBackend<DeletionConfirmInitialData>();

    const [formResponse, setFormResponse] = useState<{
        formData: DeletionSubmissionFormData;
        previewData: PostDeletePreviewResponse;
    } | null>(null);

    if (formResponse) {
        return (
            <DeletionConfirmation
                formData={formResponse.formData}
                onCancel={() => setFormResponse(null)}
                previewData={formResponse.previewData}
            />
        );
    }

    return (
        <HomeDeletionForm
            deletePartners={data.deletePartners}
            hasMultiplePartners={data.hasMultiplePartners}
            hasReasons={data.hasReasons}
            onSuccess={setFormResponse}
            userAccount={data.userAccount}
        />
    );
};

export default DeletionConfirm;
